"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const svgIcons_1 = require("../../../../svgIcons");
require("./staff.scss");
const Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
const StateFieldComponent = (params, error, placeholder) => {
    return (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { error: !!error, placeholder: placeholder })));
};
const Staff = (props) => {
    const noData = `Please edit your profile and write a staff to complete your profile.`;
    const noDataGuest = `Information is not provided.`;
    const staff = [
        { id: 0, name: 'Select Range' },
        { id: 1, name: '1-10' },
        { id: 2, name: '11-50' },
        { id: 3, name: '51 and more' }
    ];
    const currentStaff = staff.filter(el => el.id === props.inputValue)[0] || null;
    return (react_1.default.createElement(core_1.Box, { id: 'staff-block' }, !props.edit ? react_1.default.createElement("p", null, props.attorneysRange || `${props.guest ? noDataGuest : noData}`) :
        react_1.default.createElement(Autocomplete_1.default, { id: "select-staff", "data-qa": 'staff', className: currentStaff.name === 'Select Range' ? 'color-light' : '', popupIcon: react_1.default.createElement(svgIcons_1.DropdownIcon, { fill: '#2EA0DC' }), value: currentStaff, options: staff, onChange: (e, value) => props.inputChange(null, 'attorneys_range', (value === null || value === void 0 ? void 0 : value.id) || 0), getOptionLabel: (option) => option.name || '', renderInput: params => StateFieldComponent(params, false, 'Select Range') })));
};
exports.default = Staff;
